var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imgsetting"},[_c('div',{staticClass:"imgsetting-tab"},[_c('div',{staticClass:"control-item",on:{"click":_vm.fullscreen}},[_c('div',{staticClass:"control-item-title"},[_vm._v(" 全屏 ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }